import type { VoidFunctionComponent } from 'react';

import { type IssueType, type LicensingIssueType } from '../../../../../../../shared/issuesV2';
import { TooltipBadge } from '../../../../../generic';
import Icon, { type IconClassName, icons } from '../../../../../generic/Icon';
import type { BadgeColor } from '../../../../../generic';

import styles from './DependencyLicenses.module.less';

type Props = {
  issueType?: IssueType
  isIgnored?: boolean;
};

export const PolicyStatusBadge: VoidFunctionComponent<Props> = ({ issueType, isIgnored }) => {
  const issueTypeMap: Record<LicensingIssueType, string> = {
    policy_flag: 'Flagged',
    policy_conflict: 'Denied',
    unlicensed_dependency: 'Unlicensed',
    unconcluded_dependency: 'Unconcluded',
    multi_license_concluded: 'Concluded (Multi)',
  };

  // Default to a checkmark on a green badge to represent an approved license.
  let icon: IconClassName = icons.badgeCheck;
  let badgeColor: BadgeColor = 'dark-green';

  switch (issueType) {
    case 'policy_flag':
      icon = icons.flagOutline;
      badgeColor = isIgnored ? 'light-yellow' : 'yellow';
      break;
    case 'policy_conflict':
      icon = icons.banOutline;
      badgeColor = isIgnored ? 'light-red' : 'dark-red';
      break;
    default:
      break;
  }

  return (
    <TooltipBadge
      color={badgeColor}
      size="micro"
      id={`policy-status-badge-${issueType}`}
      tooltip="Issue is ignored."
      showTooltip={isIgnored}
    >
      <div className={styles.policyStatusText}>
        <Icon icon={isIgnored ? icons.eyeSlash : icon} />
        {(issueType && issueTypeMap[issueType as LicensingIssueType]) || 'Approved'}
      </div>
    </TooltipBadge>
  );
};
